import { z } from 'zod'

export const linkSchema = z.object({
  label: z.string().min(1, 'Label is required').max(100, 'Label too long (max 100 chars)'),
  href: z
    .string()
    .url('Invalid URL')
    .regex(/^https?:\/\//, 'URL must start with http:// or https://'),
  desc: z.string().max(200, 'Description too long (max 200 chars)').optional(),
  badge: z
    .enum(['official', 'video', 'pdf', 'internal', 'merch', 'instagram', 'photos'])
    .optional(),
})

export const linksDataSchema = z.object({
  links: z.array(linkSchema).max(200, 'Maximum 200 links allowed'),
})

export type LinkFormData = z.infer<typeof linkSchema>
